



































































































































































import Vue from 'vue';
import $ from 'jquery';
import 'bootstrap-select';
import { en } from '../assets/js/en.artifacts';
import { fr } from '../assets/js/fr.artifacts';
import { cn } from '../assets/js/cn.artifacts';
import { tw } from '../assets/js/tw.artifacts';
import { nicknames } from '../assets/js/nicknames';

export default Vue.extend({
  props: ['title', 'value', 'huid', 'defaultRole'],
  data() {
    return {
      artifacts: en,
      nicknames,
      modalid: 'temp',
      selectedArtifact: '',
      selectedRarity: '3',
      selectedRole: '',
    };
  },
  computed: {
    getArtifact(): Array<any> {
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 100);
      return this.getItems();
    },
  },
  created() {
    this.artifacts = this.getItems();
    this.modalid = this.huid;
  },
  mounted() {
    this.selectedRarity = '3';
    this.selectedRole = '';
  },
  watch: {
    title(): void {
      this.artifacts = this.getItems();
    },
  },
  updated() {
    $(this.$el).selectpicker({ title: this.title }).selectpicker('render');
  },
  methods: {
    setup(): void {
      let temp: any;
      temp = this.$refs[this.selectedRole];
      if (temp.attributes.checked != null) {
        temp.attributes.removeNamedItem('checked');
        temp.parentNode.classList.remove('active');
      }
      temp = this.$refs[this.selectedRarity];
      if (temp.attributes.checked != null) {
        temp.attributes.removeNamedItem('checked');
        temp.parentNode.classList.remove('active');
      }
      if (this.defaultRole !== '') {
        this.selectedRarity = '5';
        this.selectedRole = this.defaultRole;
      } else {
        this.selectedRarity = '3';
        this.selectedRole = '';
      }
      temp = this.$refs[this.selectedRole];
      temp.setAttribute('checked', 'true');
      temp.parentNode.classList.add('active');
      temp = this.$refs[this.selectedRarity];
      temp.setAttribute('checked', 'true');
      temp.parentNode.classList.add('active');
    },
    select($event: Event): void {
      this.selectedArtifact = ($event.target as HTMLInputElement).value;
      this.$emit('input', ($event.target as HTMLInputElement).value);
    },
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    getItems(): Array<any> {
      let artifacts = null;
      const filteredArtifacts = [];
      switch (this.$i18n.locale) {
        case 'en':
          artifacts = en;
          break;
        case 'fr':
          artifacts = fr;
          break;
        case 'cn':
          artifacts = cn;
          break;
        case 'tw':
          artifacts = tw;
          break;
        default:
          artifacts = en;
          break;
      }

      for (let i = 0; i < artifacts.length; i += 1) {
        if (artifacts[i].rarity.toString() === this.selectedRarity && artifacts[i].role === this.selectedRole) {
          filteredArtifacts.push(artifacts[i]);
        }
      }

      return filteredArtifacts;
    },
    getTokens(item: { _id: string }): string {
      if (item._id && nicknames[item._id]) {
        return nicknames[item._id];
      }
      return '';
    },
  },
});
